<div class="d-flex justify-content-center my-5">
  @if (slideData.newAudioPlayer) {
    <lib-audio-player-v2
      [src]="slideData.audio?.uri"
      [backgroundColor]="slideData.audioPlayerTheme === 'brand_color' && brandColors?.primaryColor"
      [textColor]="slideData.audioPlayerTheme === 'brand_color' && brandColors?.primaryTextColor"
      [title]="slideData.audioTitle"
      [preventTimeSeek]="requiredToCompleteAudio"
      (finished)="audioEnded.emit()">
    </lib-audio-player-v2>
  } @else {
    <app-audio-player
      [src]="slideData.audio?.uri"
      [preventTimeSeek]="requiredToCompleteAudio"
      (audioCompleted)="audioEnded.emit()">
    </app-audio-player>
  }

</div>
